import React from 'react';

interface IconChevronProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
}

export const IconChevron: React.FC<IconChevronProps> = ({ className, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15" height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className={className}
        {...props}
    >
        <path d="m9 18 6-6-6-6" />
    </svg>
);
